import { createAction } from 'redux-actions';

import { RESET_STATE } from '../constants/Actions';

export default createAction(RESET_STATE);
